export const passwordPolicy = ['8009b138-6a61-4e12-85cc-7842b110acda'];
export const userLockOutPolicyId = '5bbe300c-f2d6-47d2-8072-bf11f5af3656';
